var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStoreFinder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.818 2.455a4.364 4.364 0 00-4.363 4.363c0 .554.225 1.387.638 2.387.404.979.955 2.042 1.534 3.027.58.987 1.176 1.879 1.666 2.517.204.266.382.477.525.63.144-.153.321-.364.525-.63.49-.638 1.087-1.53 1.666-2.517.58-.985 1.13-2.048 1.535-3.027.413-1 .638-1.833.638-2.387a4.364 4.364 0 00-4.364-4.363zm-.234 13.143c-.018.01-.02.013 0 0zm.468 0c.019.012.018.01 0 0zM3 6.818a5.818 5.818 0 0111.636 0c0 .852-.32 1.905-.748 2.941-.437 1.059-1.022 2.183-1.625 3.21a27.163 27.163 0 01-1.765 2.664 8.766 8.766 0 01-.74.865c-.11.109-.23.215-.351.298a1.055 1.055 0 01-.589.203c-.28 0-.496-.14-.588-.203a2.615 2.615 0 01-.351-.298 8.757 8.757 0 01-.74-.865 27.151 27.151 0 01-1.766-2.665c-.603-1.026-1.188-2.15-1.625-3.209C3.321 8.725 3 7.672 3 6.82z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.818 5.364a.727.727 0 100 1.454.727.727 0 000-1.454zm-2.182.727a2.182 2.182 0 114.364 0 2.182 2.182 0 01-4.364 0z",
    fill: "#000"
  })));
}
export default SvgIconStoreFinder;